export const DeadlineIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 229 175"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      d="M.077 53.846h67.308v13.462H.077V53.846Zm20.193 80.769h53.846v13.462H20.27v-13.462ZM33.73 80.769h33.654v13.462H33.73V80.769ZM.077 107.692h60.577v13.462H.077v-13.462Zm161.539-39.707v26.246h26.246c-2.684-13.167-13.079-23.563-26.246-26.246Z"
      fill="currentColor"
    />
    <path
      d="M148.153 67.988c-15.343 3.127-26.923 16.724-26.923 32.977 0 18.556 15.096 33.653 33.653 33.653 16.253 0 29.85-11.58 32.977-26.923h-39.707V67.988Z"
      fill="currentColor"
    />
    <path
      d="M161.611 27.232v-13.77h13.461V0h-40.384v13.461h13.461v13.771c-37.682 3.412-67.308 35.173-67.308 73.73 0 40.825 33.214 74.038 74.039 74.038s74.038-33.213 74.038-74.038c0-38.557-29.625-70.318-67.307-73.73Zm-6.731 120.845c-25.98 0-47.115-21.136-47.115-47.115 0-25.98 21.135-47.116 47.115-47.116s47.115 21.137 47.115 47.116-21.136 47.115-47.115 47.115Z"
      fill="currentColor"
    />
  </svg>
);
